import type { SequencePreStep } from '~/components/Sequence/sequenceSteps';

/** The expanded detail for a pre-step: its graph sub-steps as a read-only list. */
export function SequencePreStepDetail({ preStep }: { preStep: SequencePreStep }) {
  return (
    <div className="w-72 overflow-hidden rounded-xl border border-lynch-200 bg-white shadow-xl dark:border-slate-700 dark:bg-slate-900">
      <div className="flex items-center gap-2 border-b border-lynch-200 px-3 py-2 dark:border-slate-700 [&>svg]:size-4">
        {preStep.icon}
        <span className="text-xs font-semibold text-slate-600 dark:text-slate-300">{preStep.label}</span>
      </div>
      <div className="flex flex-col gap-2.5 p-3">
        {preStep.subSteps.map((sub, i) => (
          <div key={i} className="flex gap-2">
            <span className="mt-1.5 size-1.5 shrink-0 rounded-full bg-lynch-300 dark:bg-slate-600" />
            <div className="min-w-0">
              <div className="text-xs font-medium text-slate-700 dark:text-slate-200">{sub.label}</div>
              <div className="text-[11px] leading-snug text-gray-500 dark:text-gray-400">{sub.gist}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
